import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-open-tag',
  templateUrl: './ecp-open-tag.component.html',
  styleUrls: ['./ecp-open-tag.component.css']
})
export class EcpOpenTagComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
